import { contains, map, prop } from 'ramda';

import {
  getSplashScreen,
  getSubscriptionEligibilityNotCoveredOrExceededWorkflow,
  getSubscriptionEligibilityWrongDataWorkflow
} from '../selectors/settings';

import { isNotNillNorEmpty } from './helpers';
import { SUBSCRIPTION_ELIGIBILITY_WORKFLOWS } from '../enums';

export const hasSplashScreen = state => getSplashScreen(state);

export const getPhoneCountryPreferences = (settings, local) => {
  const preferredCountries = map(prop('iso2'), settings.ELIGIBILITYCHECK_PHONE_NUMBER_FORMATS || []);
  const hasPreferredCountries = isNotNillNorEmpty(preferredCountries);

  const defaultPhoneCountry =
    hasPreferredCountries && contains({ iso2: local }, settings.ELIGIBILITYCHECK_PHONE_NUMBER_FORMATS)
      ? local
      : settings.ELIGIBILITYCHECK_DEFAULT_REGION.toLowerCase();

  return { preferredCountries, defaultPhoneCountry };
};

const createWorkflowTypeCheck = (selector, workflowType) => state => selector(state) === workflowType;

export const eligibilityWorkflow = {
  wrongData: {
    isInteraction: createWorkflowTypeCheck(getSubscriptionEligibilityWrongDataWorkflow, SUBSCRIPTION_ELIGIBILITY_WORKFLOWS.INTERACTION),
    isCallProvider: createWorkflowTypeCheck(
      getSubscriptionEligibilityWrongDataWorkflow,
      SUBSCRIPTION_ELIGIBILITY_WORKFLOWS.CALL_ASSISTANCE
    ),
  },
  notCoveredOrExceeded: {
    isInteraction: createWorkflowTypeCheck(
      getSubscriptionEligibilityNotCoveredOrExceededWorkflow,
      SUBSCRIPTION_ELIGIBILITY_WORKFLOWS.DIGITAL_EXIT
    ),
    isCallProvider: createWorkflowTypeCheck(
      getSubscriptionEligibilityNotCoveredOrExceededWorkflow,
      SUBSCRIPTION_ELIGIBILITY_WORKFLOWS.CALL_ASSISTANCE
    ),
  },
};
